const mapping = {
  requested: ['approve', 'reject'],
  approved: ['revoke'],
}

export default (status) => mapping[status] || []
